module.exports = __webpack_public_path__ + "static/img/2.0f2cfcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/2.png
// module id = S3cA
// module chunks = 0